( function( $ ) {
	let initBlock = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-industries-served' );

		$section.each( function() {
			window.app.main.customScrollbarsForSection( this );
			window.app.main.initFontAdjustment( this );
		} );
	};

	window.app.loadBlock( initBlock, 'section-industries-served', '.section-industries-served' );
} )( jQuery );
